import React, { createContext, useReducer } from 'react';
import { ConfirmState, IConfirmAction } from './ConfirmModal.types';
import { initialState, confirmModalReducer } from './ConfirmModal.reducer';

interface IConfirmContext {
  state: ConfirmState;
  dispatch: React.Dispatch<IConfirmAction>;
}

const ConfirmContext = createContext<IConfirmContext>({
  state: initialState(),
  dispatch: () => {
    return;
  },
});

const ConfirmContextProvider: React.FC<React.PropsWithChildren> = ({ children }): JSX.Element => {
  const [state, dispatch] = useReducer(confirmModalReducer, initialState());

  return <ConfirmContext.Provider value={{ state, dispatch }}>{children}</ConfirmContext.Provider>;
};

export { ConfirmContext, ConfirmContextProvider };
